import React, { useEffect } from 'react'
import CustomPie from '../Charts/CustomPie'
import { DATA_DOCUMENT } from '../../services/mock'
import { useDispatch, useSelector } from 'react-redux';
import { getDocument,userSelector } from '../../services/reduxSlices/UserSlice';

/**
 * 
 * Composant présent sur le dashbord 
 * Une Card présentant les informations sur le documents total
 * @returns Card1
 * 
 */
export default function Card1() {

    const dispatch = useDispatch()
	
	useEffect(() => {
        dispatch(getDocument({
            page: undefined,
            start: undefined,
            end: undefined,
            search: undefined
        }))
	},[])
	
	const { signDocuments } = useSelector(userSelector)

    function formatChartData(signDocuments){
        var chart_data =  {
            labels: ["Réfuser", "Signer","En attende","En cour" ],
            datasets: [
              {
                label: "Pie",
                data: [getRefusedDocument(signDocuments), getSignedDocument(signDocuments), getEnAttenteDocument(signDocuments), getEnCourDocument(signDocuments)],
                fill: true,
                backgroundColor: [
                  '#F1416C',
                  '#009EF7',
                  'rgb(228, 230, 239)',
                  'rgb(75, 192, 192)'
              ]
              }
            ],
        }

        return chart_data
    }

    function getSignedDocument(signDocuments) {
        
       const documents = signDocuments.filter(doc => doc.statut === "signe")
       const documentsCount = documents.length

       return documentsCount
    }

    function getRefusedDocument(signDocuments) {
        
        const documents = signDocuments.filter(doc => doc.statut === "refuse")
        const documentsCount = documents.length
 
        return documentsCount
    }

    function getEnCourDocument(signDocuments) {
        
        const documents = signDocuments.filter(doc => doc.statut === "en_cours")
        const documentsCount = documents.length
 
        return documentsCount
    }

    function getEnAttenteDocument(signDocuments) {
        
        const documents = signDocuments.filter(doc => doc.statut === "en_attente")
        const documentsCount = documents.length
 
        return documentsCount
    }
    
    let option_pie = {
        responsive : true,
        plugins:{
          legend : {display:false},
          title:{
            display : true,
            text :"Total document",
            position: "top" 
          }
        }
    }

  return (
    <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10">
    <div className="card card-flush h-md-60 mb-5 mb-xl-10">
        <div className="card-header pt-5">
            <div className="card-title d-flex flex-column">
                <div className="d-flex align-items-center">
                  <span className="fs-2hx fw-bolder text-dark me-2 lh-1 ls-n2">{signDocuments.data && signDocuments.data.length}</span>
                </div>
             <span className="text-gray-400 pt-1 fw-bold fs-6">Documents Total</span>
            </div>
        </div>
     <div className="card-body pt-2 pb-4 d-flex align-items-center">
            <div className="d-flex flex-center me-5">
                <div id="kt_card_widget_4_chart" style={{minWidth: '70px', minHeight: '70px'}} data-kt-size="70" data-kt-line="11">
                    <CustomPie data={ signDocuments.data ? formatChartData(signDocuments.data) : DATA_DOCUMENT} options={option_pie}/>
                </div>
            </div>
        <div className="d-flex flex-column content-justify-center w-100">
                <div className="d-flex fs-6 fw-bold align-items-center">
                    <div className="bullet w-8px h-6px rounded-2 bg-danger me-3"></div>
                 <div className="text-gray-500 flex-grow-1 me-4">Réfusé</div>
                <div className="fw-boldest text-gray-700 text-xxl-end">{signDocuments.data && getRefusedDocument(signDocuments.data)}</div>
                </div>
                <div className="d-flex fs-6 fw-bold align-items-center my-3">
                    <div className="bullet w-8px h-6px rounded-2 bg-primary me-3"></div>
                  <div className="text-gray-500 flex-grow-1 me-4">Signé</div>
                    <div className="fw-boldest text-gray-700 text-xxl-end">{signDocuments.data && getSignedDocument(signDocuments.data)}</div>
                </div>
                <div className="d-flex fs-6 fw-bold align-items-center">
                    <div className="bullet w-8px h-6px rounded-2 me-3" style={{backgroundColor: '#E4E6EF'}}></div>
                    <div className="text-gray-500 flex-grow-1 me-4">En attende</div>
                    <div className="fw-boldest text-gray-700 text-xxl-end">{signDocuments.data && getEnAttenteDocument(signDocuments.data)}</div>
                </div>
                <div className="d-flex fs-6 fw-bold align-items-center my-3">
                    <div className="bullet w-8px h-6px rounded-2 me-3" style={{backgroundColor: 'rgba(75, 192, 192)'}}></div>
                    <div className="text-gray-500 flex-grow-1 me-4">En cour</div>
                    <div className="fw-boldest text-gray-700 text-xxl-end">{signDocuments.data && getEnCourDocument(signDocuments.data)}</div>
                </div>
            </div>
        </div>
    </div>
    <div className="card card-flush h-md-50 mb-xl-10">
        <div className="card-header pt-5">
            <div className="card-title d-flex flex-column">
                <div className="d-flex align-items-center">
                    <span className="fs-2hx fw-bolder text-dark me-2 lh-1 ls-n2">News</span>
                </div>
                <span className="text-gray-400 pt-1 fw-bold fs-6"></span>
            </div>
        </div>
        <div className="card-body d-flex align-items-end pt-0">
        
        </div>
    </div>
</div>
  )
}
